"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKAlertContext = void 0;
var React = __importStar(require("react"));
var GKAlertContext_models_1 = require("./GKAlertContext.models");
// CONTEXT DEFINITION
var errorToConsole = function (m, type) {
    window.console.error(GKAlertContext_models_1.ERROR_MESSAGE + ("method: " + type + ", message: " + m));
    return {};
};
exports.GKAlertContext = React.createContext({
    id: "",
    alerts: Object.freeze([]),
    global: undefined,
    dismissAll: function () { return window.console.error(GKAlertContext_models_1.ERROR_MESSAGE + " method: dismissAll"); },
    danger: function (m) { return errorToConsole(m, "danger"); },
    info: function (m) { return errorToConsole(m, "info"); },
    primary: function (m) { return errorToConsole(m, "primary"); },
    secondary: function (m) { return errorToConsole(m, "secondary"); },
    success: function (m) { return errorToConsole(m, "success"); },
    warning: function (m) { return errorToConsole(m, "warning"); },
});
exports.default = exports.GKAlertContext;
